const AUTO_WRAP_MARKER = '|n'
let measureCanvas: HTMLCanvasElement | null = null
let lastWrapCacheKey = ''
let lastWrapCacheValue = ''

function getMeasureContext(): CanvasRenderingContext2D | null {
  if (typeof document === 'undefined') return null
  if (!measureCanvas) {
    measureCanvas = document.createElement('canvas')
  }
  return measureCanvas.getContext('2d')
}

function readTextControlToken(text: string, index: number): { token: string; measureText: string } | null {
  const rest = text.slice(index)
  const colorMatch = rest.match(/^\\c\[\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\]/i)
  if (colorMatch?.[0]) {
    return { token: colorMatch[0], measureText: '' }
  }
  const variableMatch = rest.match(/^\\[vxt]\[\s*-?\d+\s*\]/i)
  if (variableMatch?.[0]) {
    return { token: variableMatch[0], measureText: variableMatch[0] }
  }
  return null
}

function wrapLine(line: string, maxWidth: number, ctx: CanvasRenderingContext2D): string {
  let output = ''
  let measuredLine = ''
  for (let index = 0; index < line.length;) {
    const controlToken = readTextControlToken(line, index)
    if (controlToken) {
      const nextMeasured = measuredLine + controlToken.measureText
      if (controlToken.measureText && measuredLine && ctx.measureText(nextMeasured).width > maxWidth) {
        output += AUTO_WRAP_MARKER
        measuredLine = ''
      }
      output += controlToken.token
      measuredLine += controlToken.measureText
      index += controlToken.token.length
      continue
    }
    const char = Array.from(line.slice(index))[0] ?? ''
    if (!char) break
    const nextMeasured = measuredLine + char
    if (measuredLine && ctx.measureText(nextMeasured).width > maxWidth) {
      output += AUTO_WRAP_MARKER
      measuredLine = ''
    }
    output += char
    measuredLine += char
    index += char.length
  }
  return output
}

/** 移除旧自动换行标记，并把手动换行还原成编辑器可见换行。 */
export function decodeDialogTextForEdit(value: string): string {
  return String(value || '')
    .replace(/\r\n/g, '\n')
    .replace(/\|n/g, '')
    .replace(/\\n/g, '\n')
    .replace(/\/n/g, '\n')
}

/** 将编辑器文本写回事件参数，手动换行写 `\n`，自动换行写 `|n`。 */
export function encodeDialogTextFromEdit(params: {
  text: string
  enableAutoWrap: boolean
  autoWrapWidth: number
  autoWrapFont: string
}): string {
  const normalizedText = String(params.text || '').replace(/\r\n/g, '\n')
  const manualLines = normalizedText.split('\n')
  if (!params.enableAutoWrap || params.autoWrapWidth <= 0 || !normalizedText) {
    return manualLines.join('\\n')
  }
  const cacheKey = `${params.autoWrapWidth}|${params.autoWrapFont}|${normalizedText}`
  if (cacheKey === lastWrapCacheKey) return lastWrapCacheValue
  const ctx = getMeasureContext()
  if (!ctx) return manualLines.join('\\n')
  ctx.font = params.autoWrapFont
  const wrapped = manualLines
    .map((line) => wrapLine(line, params.autoWrapWidth, ctx))
    .join('\\n')
  lastWrapCacheKey = cacheKey
  lastWrapCacheValue = wrapped
  return wrapped
}

/** 将运行时文本换行标记统一成预览可用换行。 */
export function normalizeDialogTextForPreview(value: string): string {
  return String(value || '')
    .replace(/\r\n/g, '\n')
    .replace(/\|n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\/n/g, '\n')
}
